import React from 'react';

const CSS = require('./NewLabel.less');

function NewLabel() {
  return <span className={CSS.NewLabel}>new</span>;
}

export default NewLabel;
